// extracted by mini-css-extract-plugin
module.exports = {"ad":"Ad_ad__HVB8b"};